export default "__VITE_ASSET__D7sc$vAc__"